import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import { cardInfoAtom, purchaseTypeAtom, monthlyCourseIdAtom, restoreOrderIdAtom } from '@!/atoms/paymentAtom'
import { userHashAtom } from '@!/atoms/userInfoAtom'
import { useSearchCard } from '@!/Hooks/useSearchCard'
import { isBlank } from '@!/Util'
import { CircularProgressModal } from '@!/components/Modal'

export const Restore = ({ monthlyCourseHistory }) => {
  const navigate = useNavigate()
  const [userHash] = useAtom(userHashAtom)
  const [searchCardMutation] = useSearchCard(userHash)
  const [cardInfo] = useAtom(cardInfoAtom)
  const [, setMonthlyCourseId] = useAtom(monthlyCourseIdAtom)
  const [, setPurchaseType] = useAtom(purchaseTypeAtom)
  const [, setRestoreOrderId] = useAtom(restoreOrderIdAtom)

  useEffect(() => {
    if (isBlank(monthlyCourseHistory)) return

    setPurchaseType('monthly')
    setRestoreOrderId(monthlyCourseHistory.order_id)
    setMonthlyCourseId(monthlyCourseHistory.monthly_course_id)
  }, [monthlyCourseHistory])

  useEffect(() => {
    if (!searchCardMutation.isSuccess) return

    navigate('/monthly_course/select')
  }, [searchCardMutation.isSuccess, cardInfo])

  return <CircularProgressModal isOpen={searchCardMutation.isPending} />
}

export default Restore
